import { render, staticRenderFns } from "./project-bulk-actions.vue?vue&type=template&id=7f0f9ced"
import script from "./project-bulk-actions.vue?vue&type=script&lang=js"
export * from "./project-bulk-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports